import { getStoredUser, isStudentUser } from '../roles'

export const MALE_GENDER_ID = 1
export const DORMITORY_SCREEN_ROUTE = '/registration/dormitory'

const HIDDEN_FOR_MALE_STUDENTS = new Set([DORMITORY_SCREEN_ROUTE])

export const isMaleStudent = (user = getStoredUser()) =>
  isStudentUser(user) && Number(user?.gender_id) === MALE_GENDER_ID

/** Drop screens male students must not see (dormitory). Leaves other roles unchanged. */
export const filterScreensByStudentGender = (groups = [], user = getStoredUser()) => {
  if (!Array.isArray(groups) || groups.length === 0) return groups
  if (!isMaleStudent(user)) return groups

  return groups
    .map((group) => ({
      ...group,
      screens: (group.screens || []).filter(
        (screen) => !HIDDEN_FOR_MALE_STUDENTS.has(screen?.screen_route),
      ),
    }))
    .filter((group) => (group.screens || []).length > 0)
}
